import { URL_SEARCH_KEY } from "constants/urlQueryKeys";
import { safeDecodeURIComponent } from "utils/urls";

export const getSearchQuery = (urlParams: URLSearchParams) => {
  return safeDecodeURIComponent(urlParams.get(URL_SEARCH_KEY) || "") ?? "";
};
